// extracted by mini-css-extract-plugin
module.exports = {"section":"Documents_section__12yCw","select":"Documents_select__1hxZ0"};